export class OcorrenciaCabecalho {
  idCupom: string;
  integrador: string;
  integradorCpfCnpj: string;
  integradorCidadeUf: string;
  cliente: string;
  clienteCpfCnpj: string;
  clienteCidadeUf: string;
  valorTotal: number;
  vendedor: string;
  notaNumero: string;
  transportadora: string;
}
